var _mask, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceDCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_11065_2897",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0.000213623,
    width: 38,
    height: 39,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    y: 0.000213623,
    width: 38,
    height: 39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000213623H38V38.0002H0V0.000213623Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 38.0002V37.0002H0V38.0002V39.0002H38V38.0002Z",
    fill: "#D9D9D9",
    mask: "url(#path-1-outside-1_11065_2897)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11065_2897)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    transform: "translate(8 8.00024)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 19.0002C8 12.9251 12.9249 8.00024 19 8.00024C25.0751 8.00024 30 12.9251 30 19.0002C30 25.0754 25.0751 30.0002 19 30.0002C12.9249 30.0002 8 25.0754 8 19.0002Z",
    fill: "#FFD8BF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11065_2897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3613 23.0002H16.5801L16.5918 22.0803H18.3613C18.9707 22.0803 19.4785 21.9534 19.8848 21.6995C20.291 21.4417 20.5957 21.0823 20.7988 20.6213C21.0059 20.1565 21.1094 19.6135 21.1094 18.9924V18.4709C21.1094 17.9827 21.0508 17.5491 20.9336 17.1702C20.8164 16.7874 20.6445 16.4651 20.418 16.2034C20.1914 15.9377 19.9141 15.7366 19.5859 15.5999C19.2617 15.4631 18.8887 15.3948 18.4668 15.3948H16.5449V14.469H18.4668C19.0254 14.469 19.5352 14.5627 19.9961 14.7502C20.457 14.9338 20.8535 15.2014 21.1855 15.553C21.5215 15.9006 21.7793 16.3225 21.959 16.8186C22.1387 17.3108 22.2285 17.8655 22.2285 18.4827V18.9924C22.2285 19.6096 22.1387 20.1663 21.959 20.6624C21.7793 21.1545 21.5195 21.5745 21.1797 21.9221C20.8438 22.2698 20.4375 22.5374 19.9609 22.7249C19.4883 22.9084 18.9551 23.0002 18.3613 23.0002ZM17.1836 14.469V23.0002H16.0527V14.469H17.1836Z",
    fill: "#FA541C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11065_2897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(8 8.00024)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11065_2897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(8 8.00024)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceDCircle);
export default __webpack_public_path__ + "static/media/device-d-circle.708188b25bf43bec66a01c29e0c54431.svg";
export { ForwardRef as ReactComponent };